
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Mask Group 2","transform":"translate(-9007.066 289.883)","clip-path":"url(#clip-path)"}},[_c('g',{attrs:{"data-name":"twitter (5)","transform":"translate(9007.065 -289.883)"}},[_c('circle',{attrs:{"data-name":"Ellipse 1533","cx":"30","cy":"30","r":"30","transform":"translate(.001)","fill":"#55acee"}}),_c('g',{attrs:{"data-name":"Group 2671"}},[_c('path',{attrs:{"data-name":"Path 1692","d":"M48.377 21.56a14.307 14.307 0 01-4.119 1.128 7.19 7.19 0 003.154-3.966 14.355 14.355 0 01-4.554 1.74A7.177 7.177 0 0030.638 27a20.356 20.356 0 01-14.781-7.493 7.179 7.179 0 002.219 9.574 7.12 7.12 0 01-3.248-.9v.091a7.175 7.175 0 005.753 7.031 7.2 7.2 0 01-3.238.124 7.178 7.178 0 006.7 4.98 14.476 14.476 0 01-10.618 2.973 20.284 20.284 0 0010.991 3.22c13.19 0 20.4-10.927 20.4-20.4 0-.311-.007-.62-.021-.927a14.541 14.541 0 003.579-3.711z","fill":"#f1f2f2"}})])])])])
          )
        }
      }
    